import {
  CommonEventDetailId,
  SoccerEventDetailId,
} from '@collector/sportsapi-client-legacy'

import { EventInfoControls } from '../../configuration'

export const eventInfoControls: EventInfoControls = [
  {
    control: 'Referee',
  },
  {
    grid: {
      cols: '2',
      controls: [
        {
          eventDetailId: SoccerEventDetailId.WeatherConditions,
          label: 'Weather cond.',
        },
        {
          eventDetailId: SoccerEventDetailId.PitchConditions,
          label: 'Pitch cond.',
        },
      ],
    },
  },
  {
    grid: {
      cols: '3',
      controls: [
        {
          eventDetailId: SoccerEventDetailId.PeriodLength,
          postfix: 'min',
          maxlength: 3,
        },
        {
          eventDetailId: CommonEventDetailId.HasLineups,
          wide: true,
        },
        'TeamColorsSwitch',
        {
          eventDetailId: SoccerEventDetailId.ExtraPeriodLength,
          label: 'Extra period',
          maxlength: 3,
          postfix: 'min',
        },
        {
          eventDetailId: SoccerEventDetailId.HasFormations,
          wide: true,
        },
        'ShotsCoordinatesSwitch',
      ],
    },
  },
  {
    control: {
      eventDetailId: SoccerEventDetailId.ExtraPeriodType,
      label: 'Ex.period type',
    },
  },
]
